/*
  Na barra escura (ADR 0055) o item ativo é uma pílula branca translúcida, como
  no cabeçalho do site. Não é azul de propósito: azul forte na navegação
  competiria com o botão primário da própria tela.
*/
export const CLASSE_DO_ITEM_ATIVO = 'bg-white/12 font-semibold text-tinta-900'
export const CLASSE_DO_ITEM_INATIVO = 'text-tinta-600 hover:bg-white/8 hover:text-tinta-900'
